import SectionHeader from "../UI/SectionHeader";
import Card from "../UI/Card";
import style from "./Contact.module.css";
import phone from "../../Assets/Images/phone.svg";
import linkedIn from "../../Assets/Images/linkedin.svg";
import gmail from "../../Assets/Images/gmail.svg";
import github from "../../Assets/Images/github1.svg";
import { useInView } from "react-intersection-observer";
import avatar from "../../Assets/Images/hey.png";
const Contact = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "30%",
    threshold: 0.5,
  });
  return (
    <>
      <SectionHeader
        className={style["section-header"]}
        title="CONTACT"
        titleSpan="ME"
        span="D"
      />
      <div
        id="contact"
        ref={ref}
        className={`${style["contact-section"]} ${
          inView ? style.animation : ""
        }`}
      >
        <Card className={style.card}>
          <div>
            <img src={avatar} alt="goodbye" />
          </div>
          <p>
            Now that you must have gone through my recent Projects, i hope
            you're impressed, kindly reach out to me via the links below to Hire
            me or for Collaborations. I'm also open to suggestion about my works
            Do well to reach out, i'll be waiting. Thank you!
          </p>
        </Card>
        <div className={style["contact-info"]}>
          <ul>
            <li>
              <a href="Tel:+2347052420943">
                <img src={phone} alt="Contact" />
              </a>
            </li>

            <li>
              <a
                href={encodeURI(
                  "mailto:moyosoree.o@gmail.com?subject=I'd love to hire you"
                )}
              >
                <img src={gmail} alt="Contact" />
              </a>
            </li>
            <li>
              <a href={encodeURI("https://github.com/MoyosoreeO")}>
                <img src={github} alt="Contact" />
              </a>
            </li>
            <li>
              <a href={encodeURI("linkedin.com/in/olaojo-jamiu-58499824b")}>
                <img src={linkedIn} alt="Contact" />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className={style.copyright}>©Moyo.lao 2022</p>
        </div>
      </div>
    </>
  );
};

export default Contact;
